
import { ghrSingleIsinName, name360T, snapshotName } from '../../../../constants/ORDER_DETAILS';
import { SINGLE_ISIN_PRODUCT_ID } from '../../../../constants/REPORTS';
import { findCategoryByName } from '../../productOverview/ProductHelper';

interface ISubscriptionBoxType {
    text: string;
    contactText?: string;
    buttonTitle: string;
    condition: (params: any) => boolean;
    pathname: string;
    getState?: (params: any) => {};
}

const subscriptionBoxTypes: ISubscriptionBoxType[] = [
    {
        text: "As you have already subscribed to this data, you will be navigated to My requests/reports section by clicking on “Go to my reports.“ There you can find all your reports and download them.",
        buttonTitle: "Go to my reports",
        condition: ({ isSubscribed, productId }) => isSubscribed && productId === SINGLE_ISIN_PRODUCT_ID,
        pathname: "/my-account/my-reports"
    },
    {
        text: "As you have already subscribed to this data, you will be navigated to the files by clicking on “Go to subscription”. If you would like to receive additional data on a regular basis, please select another product and submit a subscription request.",
        buttonTitle: "Go to subscription",
        condition: ({ isSubscribed }) => isSubscribed,
        pathname: "/my-account/my-subscriptions"
    },
    {
        text: "If you would like to receive the data regularly, please click on “Send subscription request” and enter your name, e-mail address and company.",
        contactText: "We will contact you shortly.",
        buttonTitle: "Send subscription request",
        condition: () => true,
        pathname: "/subscription-request",
        getState: ({ categories, product }) => ({
            subject: `Subscription request: ${findCategoryByName(categories, product?.category)?.name} - ${product?.name
                }`,
            product: product?.id
        })
    },
];

export const getSubscriptionBoxType = (params: any): ISubscriptionBoxType => {
    return subscriptionBoxTypes?.find(t => t.condition(params));
}

interface ISubscriptionBoxAdditionalTextType {
    text: string;
    condition: (params: any) => boolean;
}

const subscriptionBoxAdditionalText: ISubscriptionBoxAdditionalTextType[] = [
    {
        text: "Please be advised, that only one snapshot per day at one selectable time point can be subscribed, i.e. only subscription to 07:00 or 15:00 or 16:00 or 22:00 UTC snapshot is possible.",
        condition: ({ productId }) => productId.includes(name360T) && productId.includes(snapshotName),
    },
    {
        text: "Disclaimer: The Geographical Holdings Report is a snapshot of Clearstream holdings taken at approximately 20:25 CET. In addition, the report is anonymised and censored in line with our regulatory and governance requirements. Values reported may therefore not match holdings reported elsewhere.",
        condition: ({ isSubscribed, productId }) => !isSubscribed && productId.includes(ghrSingleIsinName)
    }
];

export const getSubscriptionBoxAdditionalText = (params: any): ISubscriptionBoxAdditionalTextType => {
    return subscriptionBoxAdditionalText?.find(t => t.condition(params));
}